export default __webpack_public_path__ + "static/media/Rush Down.898c5d1b.png";